import React, { FC } from 'react';

export const IconArrowDownSmall: FC<React.PropsWithChildren<{ className?: string }>> = ({ className = '' }) => {
  return (
    <svg className={className} width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L5.65517 5L10 1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};
